import { Component, OnInit } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { ActivatedRoute, Router } from '@angular/router';
import { SlideService } from '../../../appshared/web/slide/slide.service';
import { AppLoaderService } from '../../../common/service/app-loader/app-loader.service';
import { TranslateService } from '@ngx-translate/core';
import { SlideModule } from '../../../appshared/web/slide/slide.module';
import { MatTableDataSource } from '@angular/material/table';
import { OwlOptions } from 'ngx-owl-carousel-o';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

    public SelectedLanguage: string = "en";
    public dataSourceSlide = new MatTableDataSource<SlideModule>();
    ComID: number = 2;
    public apiURL: string = "";

    //slides = [
    //    { photoPath1: 'assets/img/banner.jpg', name: 'Item 1' },
    //];

    constructor(public router: Router, private route: ActivatedRoute, private servSlide: SlideService, private loader: AppLoaderService, public translate: TranslateService) { }

    ngOnInit(): void {
       

        this.apiURL = environment.apiUrl2 + 'Attachment/Companies/' + this.ComID + '/GnAtt/';
        this.fillSlide();

        if (this.translate.currentLang != undefined) {
            this.SelectedLanguage = this.translate.currentLang;
        }
        if (this.SelectedLanguage == 'ar') {

            this.slideConfig = {
                ...this.slideConfig,
                rtl: true,
            };

            this.heroSlides = {
                items: 1,
                loop: true,
                nav: false,
                dots: true,
                autoplay: true,
                rtl: true,
                smartSpeed: 1000,
                autoplayHoverPause: true

            }
        }
        else {
            this.slideConfig = {
                ...this.slideConfig,
                rtl: false,
            };
        }
    }

    slideConfig = {
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        infinite: true,
        dots: true,
        arrows: true,
        rtl: false,
    };

    fillSlide() {
        //    this.loader.open();
        this.servSlide.getService(this.ComID, 'Slide')
            .subscribe((res: SlideModule[]) => {
                this.loader.close();

                this.dataSourceSlide.data = res;


            },
                (err: any) => {
                    this.loader.close();
                    console.log(err);
                });
    }

    heroSlides: OwlOptions = {
        items: 1,
        loop: true,
        nav: false,
        dots: true,
        autoplay: true,
        smartSpeed: 1000,
        autoplayHoverPause: true

    }

    
}
